<template>
  <div class="user-basic">
    <router-link
      :to="{ name: 'profile', params: { id: user.id } }"
      class="body-color container"
    >
      <avatar
        :user="user"
        :size="72"
      />
      <div class="text">
        <div class="name">
          {{ user.first_name }} {{ user.last_name }}
        </div>
        <div class="bio">
          {{ user.bio }}
        </div>
      </div>

      <div class="follow">
        <follow-unfollow
          :other-user="user"
          :btn-class="'btn btn-primary btn-sm'"
        />
        <block-unblock
          :other-user="user"
          :btn-class="'btn btn-primary btn-sm'"
        />
      </div>
    </router-link>
    <hr v-if="!last">
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import FollowUnfollow from '@/components/FollowUnfollow.vue';
import BlockUnblock from '@/components/BlockUnblock.vue';

export default {
  name: 'UserBasic',
  components: {
    Avatar,
    FollowUnfollow,
    BlockUnblock,
  },
  props: {
    user: { type: Object, required: true },
    last: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.text {
  display: inline-block;
  margin-left: 15px;
  vertical-align: top;

  .name {
    color: var(--blue);
  }

  .bio {
    position: relative;
    font-size: 12px;
    max-height: 48px;
    max-width: 500px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bio:after {
    content: "";
    text-align: right;
    position: absolute;
    top: 32px;
    right: 0;
    height: 16px;
    width: 25%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%);
  }
}

.user-basic {
  position: relative;

  .follow {
    position: absolute;
    top: 4px;
    right: 12px;
  }
}

@media (max-width: 1024px) {
  .text {
    display: block;
    margin-top: 10px;

    .bio {
      max-width: 100%;
    }
  }

  hr {
    margin-top: 0px;
  }
}
</style>
